module.exports = __webpack_public_path__ + "static/media/project1.024e6fa3.jpg";